import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface StoreUnit {
  id: string;
  name: string;
  isHeadquarters: boolean;
  document: string | null;
  tradeName: string | null;
  city?: string | null;
  state?: string | null;
  ibgeCode?: string | null;
  segment?: string | null;
}

interface StoreContextState {
  stores: StoreUnit[];
  activeStoreId: string | null; // null = Visão Consolidada (Matriz vê tudo)
  setStores: (stores: StoreUnit[]) => void;
  setActiveStore: (storeId: string | null) => void;
  getActiveStore: () => StoreUnit | null;
  getDefaultStoreId: () => string | null;
}

export const useStoreContext = create<StoreContextState>()(
  persist(
    (set, get) => ({
      stores: [],
      activeStoreId: null,
      setStores: (stores: StoreUnit[]) => {
        set({ stores });
        // Auto-select headquarters if no active store and only one store
        const { activeStoreId } = get();
        if (!activeStoreId && stores.length === 1) {
          set({ activeStoreId: stores[0].id });
        }
      },
      setActiveStore: (storeId: string | null) => {
        set({ activeStoreId: storeId });
        window.dispatchEvent(
          new CustomEvent('vsys:storeChanged', { detail: { storeId } }),
        );
      },
      getActiveStore: () => {
        const { stores, activeStoreId } = get();
        if (!activeStoreId) return null;
        return stores.find((s) => s.id === activeStoreId) || null;
      },
      getDefaultStoreId: () => {
        const { stores, activeStoreId } = get();
        if (activeStoreId) return activeStoreId;
        // Fallback: first headquarters, or first store
        const hq = stores.find((s) => s.isHeadquarters);
        return hq?.id || stores[0]?.id || null;
      },
    }),
    {
      name: 'vsys-store-context',
    },
  ),
);
